import { Divider, TitleContainer, TitleForm } from "./Style";

interface TmpTitleFormCustomProps {
    children: React.ReactNode;
    marginTop?: number;
    marginBottom?: number;
}


export default function TmpTitleFormCustom(props: TmpTitleFormCustomProps) {

    return (
        <>
            <TitleContainer marginBottom={props.marginBottom} marginTop={props.marginTop}>

                <TitleForm >
                    {props.children}
                    <Divider />
                </TitleForm>
            </TitleContainer>
        </>
    )
}